export class ReportAssetsModelBase {
    errorMessage:string = "";
    name:string = "";
    location: string = "";
    locationSite: string = "";
    assetType:string = "";
    department:string = "";
    disposalStatus: string = "";
    tagType: string = "";
    showTagType: boolean = true;
    checkedinStatus:string = "";
    missing: string = "";
    tagTypes:string[] = ["", "Not Tagged", "Tagged", "GPS Tag", "V-Tag", "Passive Tag"];
    checkinStatuses:string[] = ["","Checked In", "Checked Out"];
    disposalStatuses:string[] = ["","In Service", "Dipsosed"];
    trueFalses:string[] = ["","True", "False"];
    totalCount:number = 0;
    getReportName():String{
        return "Assets Report";
    }    
    getReport():ng.IPromise<any>{
        return null;
    }

    getCount():ng.IPromise<number>{
        return null;
    }
}
